import { flushSync } from 'react-dom';
import { showWarningToast } from 'features/toastSlice';
import { setCorporateProfileData, setIsBraincareUser } from 'features/userSlice';
import { setToken } from 'utils/tokens';
import {
  clearPendingPostLoginRedirect,
  getPendingPostLoginRedirect,
  rewriteMemberReportsPathForBraincareAdmin,
} from 'utils/postLoginRedirect';
import { getLoginSuccessPendingRedirectStep } from 'pages/auth/DirectLogin/directLoginRedirectSession';

export function completeCorporateLogin({ data, navigate, dispatch, t }) {
  const { user } = data;
  const roles = Array.isArray(data.roles) ? data.roles : [];

  setToken('access_token', data.access_token);
  setToken('refresh_token', data.refresh_token);

  const pendingPathSnapshot = getPendingPostLoginRedirect();
  flushSync(() => {
    dispatch(setCorporateProfileData(data));
  });

  if (user?.accept_terms === false) {
    navigate('/auth/accept-terms');
    return false;
  }

  const skipOrgAlign = Boolean(data.user?.braincare_permissions?.length);
  const redirectStep = getLoginSuccessPendingRedirectStep({
    pendingPath: pendingPathSnapshot,
    loginOrganizationId: data.organization?.id,
    skipOrgAlign,
  });

  if (redirectStep === 'wrong-org-show-toast') {
    dispatch(showWarningToast(t('auth.login.email-link-wrong-org')));
  } else if (redirectStep === 'try-pending-navigate' && pendingPathSnapshot) {
    const navTarget = skipOrgAlign
      ? rewriteMemberReportsPathForBraincareAdmin(pendingPathSnapshot)
      : pendingPathSnapshot;
    clearPendingPostLoginRedirect();
    navigate(navTarget, { replace: true });
    return true;
  }

  dispatch(setIsBraincareUser(false));

  if (roles.length === 1) {
    const role = roles[0];

    if (role.id === 1) {
      navigate('/organization/members');
      return false;
    }

    if (role.id === 3) {
      navigate('/organization/physio');
      return false;
    }
  }

  navigate('/');
  return false;
}
